import React, { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Item } from 'drf-react-by-schema';

import { useAppSelector } from 'src/app/hooks';
import { useHasPermissionsMulti } from 'src/hooks/useHasPermissions';
import { GENERAL_ADMINS, GROUP_VIEWS, Perfil } from 'src/constants';
import { PerfilType } from 'src/@types';

import MetabaseAppEmbed from '../components/MetabaseAppEmbed';

function buildPayload(view?: Perfil, perfil?: PerfilType | null) {
  if (!view || !perfil?.usuaria) {
    return null;
  }
  let dashboard: number = 0;
  const params: Item = {};
  switch (view) {
    case Perfil.QUEBRADEIRA:
      dashboard = 7;
      params.quebradeira = [perfil.nome];
      break;
    case Perfil.DIRECAO:
    case Perfil.SUPERADMIN:
      dashboard = 8;
      break;
  }

  const payload = {
    resource: { dashboard },
    params,
  };
  return payload;
}

export default function Relatorios() {
  const { perfil } = useAppSelector((state) => state.page);
  const [isGroupView, isAdmin] = useHasPermissionsMulti([GROUP_VIEWS, GENERAL_ADMINS]);
  const navigate = useNavigate();

  const payload = useMemo(
    () =>
      buildPayload(isGroupView ? Perfil.QUEBRADEIRA : isAdmin ? Perfil.DIRECAO : undefined, perfil),
    [perfil, isGroupView, isAdmin]
  );

  useEffect(() => {
    if (perfil && !payload) {
      navigate('/');
    }
  }, [perfil, payload]);

  if (!payload) {
    return;
  }

  return (
    <MetabaseAppEmbed
      className="metabaseDashboard"
      payload={payload}
      // onFrame={(frameLoaded) => {
      //   handleLoading(frameLoaded);
      // }}
      titled={false}
    />
  );
}
